import React from 'react';
import { SiNextdotjs, SiJavascript, SiReact, SiPhp, SiLaravel, SiHtml5, SiCss3, SiNodedotjs } from "react-icons/si";

import Carousel from '../../../components/Carousel';

import { SSection } from '../../../styles/pages/Home';
import theme from '../../../styles/theme';

const SkillsDate = [
    {
        icon: <SiReact color='#61dafb' size={40} />,
        title: 'React Js'
    },
    {
        icon: <SiNextdotjs color='#000000' size={40} />,
        title: 'Next Js'
    },
    {
        icon: <SiJavascript color='#efd81d' size={40} />,
        title: 'Javascript'
    },
    {
        icon: <SiNodedotjs color='#84ba64' size={40} />,
        title: 'Node Js'
    },
    {
        icon: <SiPhp color='#7e6fb4' size={40} />,
        title: 'Php'
    },
    {
        icon: <SiLaravel color='#e33829' size={40} />,
        title: 'Laravel'
    },
    {
        icon: <SiHtml5 color='#f25409' size={40} />,
        title: 'Html'
    },
    {
        icon: <SiCss3 color='#00a5d5' size={40} />,
        title: 'Css'
    },


]


const Skills: React.FC = () => {
    return (
        <SSection backgroundcolor={theme.colors.primary}>
            <div className='container'>
                <h1>Habilidades</h1>
                <span className="sub-title">Habilidade</span>
                <Carousel items={SkillsDate} />
            </div>
        </SSection>
    );
}

export default Skills;